import * as Yup from "yup";
import { urlValidation } from "../../CloudStorage/CommonFunction";


export const pricevalidation = Yup.string()
  .required("Price is required")
  .test("not-zero", "Price cannot be 0", (value) => {
    return value && Number(value) > 0;
  });



export const titlevalidation = Yup.string().required("This is required").test("not-only-spaces", "This is required", (value) => value && value.trim() !== "").max(250, "This cannot exceed 250 characters");
export const nospecialtitle = Yup.string().required("This is required").test("not-only-spaces", "This is required", (value) => value && value.trim() !== "").matches(/^[A-Za-z0-9 ]+$/, "Special characters are not allowed").max(250, "This cannot exceed 250 characters");

export const namevalidation = Yup.string()
  .required("This is required")
  .test("not-only-spaces", "This is required", (value) => value && value.trim() !== "")
  .matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces")
  .max(250, "Name cannot exceed 250 characters");

export const descriptionvalidation = Yup.string()
  .required("This is required")
  .test(
    "not-empty-html",
    "This is required",
    (value) => {
      if (!value) return false;
      const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim();
      return text.length > 0;
    }
  )
  .test(
    "no-contact-info",
    "Contact information (emails/phone numbers) is not allowed in this field.",
    (value) => {
      if (!value) return true;
      const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
      const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
      const PHONE_REGEX = /(\+?\d{1,4}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4,12}/g;
      return !EMAIL_REGEX.test(text) && !PHONE_REGEX.test(text);
    }
  )
  .max(10000, "This cannot exceed 10000 characters");

// Yup.string()
//   .required("This is required")
//   .test(
//     "not-empty-html",
//     "This is required",
//     (value) => {
//       if (!value) return false;

//       // Strip HTML tags and &nbsp; spaces
//       const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim();

//       return text.length > 0;
//     }
//   )
//   .max(10000, "This cannot exceed 10000 characters");

export const aboutMeValidation = Yup.string()
  .required("This is required")
  .test(
    "not-empty-html",
    "This is required",
    (value) => {
      if (!value) return false;
      const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim();
      return text.length > 0;
    }
  )
  .test(
    "no-contact-info",
    "Contact information (emails/phone numbers) is not allowed in this field.",
    (value) => {
      if (!value) return true;
      const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
      const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
      const PHONE_REGEX = /(\+?\d{1,4}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4,12}/g;
      return !EMAIL_REGEX.test(text) && !PHONE_REGEX.test(text);
    }
  )
  .max(10000, "This cannot exceed 10000 characters");

export const emailvalidation = Yup.string()
  .transform((value) => (value ? value.trim() : "")) // <-- TRIM FIX
  .email("Invalid email format")
  .matches(
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    "Invalid email format"
  )
  .required("Email is required");

export const passwordvalidation = Yup.string()
  .required("Password is required")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_+=.\-])[A-Za-z\d@$!%*?&^#()_+=.\-]{8,}$/,
    "Password must be at least 8 characters, include uppercase, lowercase, number, and special character, and should not contain spaces"
  );

export const validurlvalidation = Yup.string()
  .required("URL is required")
  .test("valid-url", "Enter a valid URL", (value) => urlValidation(value));


export const price2validation = Yup.number()
  .required("This is required")
  .test(
    "price2-greater-or-equal",
    "To Price must be greater than or equal to From Price",
    function (value) {
      const { price } = this.parent;
      return value >= price;
    }
  );


export const bankvalidationSchema = Yup.object().shape({
  bank_name: Yup.string().required("Bank name required").test("not-only-spaces", "Bank name required", (value) => value && value.trim() !== "").matches(/^[A-Za-z0-9 ]+$/, "Special characters are not allowed").max(250, "This cannot exceed 250 characters"),
  account_holder_name: Yup.string().required("Account holder name required").test("not-only-spaces", "Account holder name required", (value) => value && value.trim() !== "").matches(/^[A-Za-z0-9 ]+$/, "Special characters are not allowed").max(250, "This cannot exceed 250 characters"),
  account_number: Yup.string()
    .matches(/^[A-Za-z0-9]+$/, "Account number must be alphanumeric")
    .required("Account number is required"),
  confirm_account_number: Yup.string()
    .oneOf([Yup.ref("account_number"), null], "Account numbers must match")
    .required("Confirm account number is required"),
  ifsc_code: Yup.string()
    .matches(/^[A-Za-z0-9]+$/, "Bank code must be alphanumeric")
    .required("Bank code is required"),
  swift_code: Yup.string()
    .matches(/^[A-Za-z0-9]+$/, "SWIFT code must be alphanumeric")
    .required("SWIFT code is required"),
});



const getTodayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const lastdatevalidation = Yup.string()
  .required("This is required")
  .test(
    "is-not-past-date",
    "Date cannot be in the past",
    function (value) {
      if (!value) return true; // handled by required
      const today = new Date(getTodayDate());
      const selectedDate = new Date(value);
      // Compare only date part (ignore time)
      return selectedDate >= today;
    }
  );

export const filesvalidationforstatusbase = Yup.array()
  .test(
    "has-min-one-file",
    "At least one file is required",
    function (files) {
      if (!Array.isArray(files)) return false;

      const validFiles = files.filter(file => file.status != 3);

      return validFiles.length >= 1;
    }
  )
  .test(
    "max-five-files",
    "You cannot upload more than 5 files",
    function (files) {
      if (!Array.isArray(files)) return false;

      const validFiles = files.filter(file => file.status != 3);

      return validFiles.length <= 5;
    }
  );


export const mobilenumbervalidation = Yup.string()
  .required("This field is required")
  .when("country_code", {
    is: "+91",
    then: (schema) =>
      schema.matches(/^[0-9]{10}$/, "Number must be exactly 10 digits"),
    otherwise: (schema) =>
      schema
        .min(9, "Minimum of 9 digits should be there")
        .max(12, "Maximum of 12 digits should be there"),
  });
